<template>
  <div>
    <v-card>
      <div class="pa-2 mt-2">
        <v-row no-gutters class="align-center">
          <v-col cols="12" md="9">
            <h2 class="px-2">{{ count }} {{ $t("theBets") }}</h2>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('searchLabelBetonline')"
              single-line
              hide-details
              solo-inverted
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </div>

      <v-data-table
        :headers="headers"
        :items="items"
        class="elevation-1 historic-bet"
        :search="search"
        :dense="$vuetify.breakpoint.smAndDown"
        ref="dataTable"
        @update:page="$vuetify.goTo($refs.dataTable)"
        @pagination="updateCount"
      >
        <!-- Remove o Items para search -->
        <template v-slot:item.search="{ item }" class="d-none"> </template>
        <!-- Constroi os itesm de eventos -->
        <template v-slot:item.events="{ item }">
          <template v-if="!$vuetify.breakpoint.smAndDown">
            <div>
              <div
                v-for="(event, index) in item.events"
                :key="index"
                class="caption"
              >
                {{ event.description }} (
                {{ $infoTable.markets(event.id_market).name_market || "" }} -
                {{ $infoTable.outcomes(event.id_outcome).name_outcome || "" }}
                - {{ event.factor_event }}) &nbsp;
                <span
                  class="font-weight-black"
                  v-html="
                    $infoTable.conference(
                      event.result_event,
                      event.status_event
                    )
                  "
                ></span>

                <v-chip
                  class="ml-2 font-weight-black"
                  small
                  color="blue"
                  v-if="event.live_event == '1'"
                >
                  {{ $t("chipIsLive") }}
                </v-chip>
                <!-- 
                <v-chip
                  class="ml-2 font-weight-black"
                  small
                  color="warning"
                  v-if="
                    legendActiveEvent[event.active_event] &&
                      event.status_event == 1
                  "
                >
                  {{ legendActiveEvent[event.active_event] }}
                </v-chip> -->
              </div>
            </div>
          </template>
          <template v-else>
            {{ item.events.length }}
          </template>
        </template>

        <template v-slot:item.date="{ item }">
          <span class="caption">{{ item.date }}</span>
        </template>
        <template v-slot:item.amount="{ item }">
          <div>
            <v-chip
              class="font-weight-black"
              x-small
              color="blue"
              v-if="item.debita_saldo == '3'"
            >
              {{ $t("chipIsBonus") }}
            </v-chip>
          </div>
          <div>
            <span>{{ item.amount }}</span>
          </div>
        </template>

        <template v-slot:item.prize="{ item }">
          <span>{{ item.prize }}</span>
        </template>

        <template v-slot:item.paid="{ item }">
          <v-icon :color="item.paid == 0 ? 'grey' : 'green'">{{
            item.paid | formatPaid
          }}</v-icon>
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn
            light
            small
            title="Vizualizar"
            @click="showBetDialogOnline(item)"
          >
            <span v-show="$vuetify.breakpoint.smAndDown">{{ $t("show") }}</span>
            <v-icon :right="$vuetify.breakpoint.smAndDown" size="24"
              >mdi-magnify-plus-outline</v-icon
            >
          </v-btn>
        </template>

        <template v-slot:item.result_bet="{ item }">
          <div
            class="font-weight-black"
            v-html="$infoTable.conference(item.result_bet, item.status_bet)"
          ></div>
        </template>
      </v-data-table>
    </v-card>
    <div class="mt-4">
      <Resume
        :data_resume="{
          data: items,
          keys: ['bet_amount', 'prize_paid', 'prize_no_paid', 'prize'],
          showSum: false,
          hideAlert: true,
        }"
      />
    </div>

    <!-- Resume Perído -->
    <!-- <div class="mt-4" v-if="resume.amountTotal">
      <v-row>
        <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
        <v-col cols="12" xs="12" sm="6" md="4">
          <v-card class="pa-3">
            <div class="subtitle-1 mb-2">{{ $t("periodSummaryTitle") }}</div>
            <v-simple-table>
              <template>
                <tbody>
                  <tr>
                    <td>{{ $t("periodSummaryValue") }}</td>
                    <td class="text-right grey--text darken-4">
                      {{ resume.amountTotal }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("periodSummaryPrizesPaid") }}</td>
                    <td class="text-right green--text darken-4">
                      {{ resume.prizePaid || "0.00" }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("periodSummaryPossibleAwards") }}</td>
                    <td class="text-right orange--text darken-4">
                      {{ resume.prizeNoPaid || "0.00" }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("periodSummaryTotalPrizes") }}</td>
                    <td class="text-right grey--text darken-4">
                      {{ resume.prizeTotal || "0.00" }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </div> -->

    <!-- Dialog da aposta -->
    <DialogBetOnline />
  </div>
</template>
<style>
/* Oculta no mobile 'events_edited' e 'Valor_some' */
.historic-bet.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
  max-height: 56px !important;
  min-height: 32px !important;
  border-bottom: 1px dashed #000;
}
.historic-bet td.v-data-table__mobile-row:nth-child(1),
.v-data-table-header-mobile {
  display: none;
}
.historic-bet.v-data-table
  > .v-data-table__wrapper
  td.v-data-table__mobile-row:last-child {
  height: 56px !important;
  border-bottom: 6px solid #000 !important;
}
.historic-bet td.v-data-table__mobile-row:nth-child(2) {
  height: 56px !important;
  font-size: 18px;
  border-bottom: 0px !important;
}
</style>
<script>
import Resume from "@/components/backoffice/resume_global/resume";
import DialogBetOnline from "../../_components/dialog-bet-online/dialog-bet-online.vue";
export default {
  components: {
    DialogBetOnline,
    Resume,
  },
  data: () => ({
    // Select Values
    select: "",
    items: [],
    search: "",
    resume: {},
    count: 0,
    rangeValid: "",
  }),
  computed: {
    betDialog() {
      return this.$store.state.dialogBetOnline;
    },
    headers() {
      return [
        // Coluna "Oculta" com string com informações
        // para serem encontradas na busca.
        { text: "", value: "search", align: " d-none" },
        // Exibidos
        { text: this.$t("betCode"), value: "id" },
        { text: this.$t("listBetOnlineHeaderDateHour"), value: "date" },
        // { text: "Jogador", value: "name_user" },
        { text: this.$t("listBetOnlineHeaderEvents"), value: "events" },
        { text: this.$t("totalOdds"), value: "factor_bet" },
        {
          text: this.$t("listBetOnlineHeaderAmount"),
          value: "amount",
          align: "center",
        },
        { text: this.$t("listBetOnlineHeaderPrize"), value: "prize" },
        { text: this.$t("listBetOnlineHeaderResultBet"), value: "result_bet" },
        { text: this.$t("listBetOnlineHeaderPaid"), value: "paid" },
        { text: this.$t("listBetOnlineHeaderAction"), value: "action" },
      ];
    },
    // Global Filters
    rangeGlobalDate() {
      return this.$store.state.rangeGlobal.date;
    },
    selectStatusBetOnline() {
      return this.$store.state.filters.selectStatusBetOnline.status;
    },
    eventNumber() {
      return this.$store.state.filters.eventNumber.value;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
  },

  created() {
    try {
      this.$store.commit("SetRangeGlobalSelect", {
        label: this.$t("lastSevenDaysLable"),
        value: "lastSevenDays",
      });
    } catch (error) {
      // console.log(error);
    }
  },
  async mounted() {
    try {
      this.rangeValid = await this.rangeGlobalDate;
    } catch (error) {
      // console.log(error);
    }
  },

  watch: {
    saveFilters(val) {
      val && this.listBets();
    },
    rangeValid(val) {
      val && this.listBets();
    },
  },
  methods: {
    // Count Bets
    updateCount(items) {
      this.count = items.itemsLength;
    },

    listBets() {
      const body = {
        ...this.rangeGlobalDate,
        premios: this.selectStatusBetOnline,
        tipo: this.eventNumber,
      };

      this.$request
        .post("player/online/betsOnline/list", body)
        .then((response) => {
          if (response.status === 200) {
            this.count = response.data.dados.apostas.length;
            this.items = response.data.dados.apostas.map((item) => {
              // Format Date
              item.date = new Date(
                item.date.replace(" ", "T")
              ).toLocaleString();

              // Create Valor Apostas (Substituindo o amount para o resume)
              item.bet_amount = Number(item.amount) * -1;

              // Create Keys Premios pagos e nao pagos
              if (
                item.paid == "1" &&
                (item.result_bet == "1" || item.result_bet == "2")
              ) {
                item.prize_paid = item.prize;
                item.prize_no_paid = "0";
              } else {
                item.prize_paid = "0";
                item.prize_no_paid = item.prize;
              }

              // Create item search
              item.search = item.events.map((search) => {
                search = `${search.description} ${search.tournaments_name}
                 ${this.$infoTable.markets(search.id_market).name_market}
                  ${this.$infoTable.outcomes(search.id_outcome).name_outcome}
                ${this.$infoTable.results(item.result_bet)}`;
                return search;
              });
              return item;
            });
            this.items.sort(function(a, b) {
              if (a.id < b.id) {
                return 1;
              }
              if (a.id > b.id) {
                return -1;
              }
              // a must be equal to b
              return 0;
            });
          }
        })
        .catch((error) => {
          const msg = error.response.data.messages.error;
          const color = "warning";
          this.$store.commit("setNotification", { msg, color });
          this.items = [];
        });
    },

    showBetDialogOnline(item) {
      this.$store.commit("showBetDialog", {
        status: true,
        value: item,
      });
    },
  },
  filters: {
    formatPaid(val) {
      const format = val == 1 ? "mdi-check" : "mdi-minus";
      return format;
    },
  },
};
</script>
